import { LatamAgentPage } from '@/screens/Latam/Agents/LatamAgentPage';

export default function AgentTenderFailuresPage() {
  return <LatamAgentPage locale="es-CO" agentKey="tender_failures" />;
}
